import { useMutation, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { FaAward, FaCannabis, FaHandHoldingDollar } from "react-icons/fa6";
import queries from "../queries";
import {
  closeLoading,
  currency,
  getCurrCurrency,
  isMobileScreen,
  MIN_TRENDING_PRODUCT,
  productSortBy,
  productType,
  productTypeURL,
  setPageTitle,
  showLoading,
} from "../common";
import { ImportMainJs } from "../helper/ImportScript";
import ProductCard from "./mini/ProductCard";
import { FaShippingFast } from "react-icons/fa";
import { TbShieldDollar } from "react-icons/tb";
import Newsletter from "./Newsletter";
function Home({ dataSelf, refetch: refetchSelf }) {
  const [addProductToCart] = useMutation(queries.member.ADD_PRODUCT_TO_CART);

  setPageTitle("Best Online Kratom, Hemp, Delta 8 & CBD Store");
  const {
    loading: naLoading,
    error: naError,
    data: dataNewArrivals,
  } = useQuery(queries.products.GET_NEW_ARRIVALS);

  const {
    loading: soLoading,
    error: soError,
    data: dataSpecialOffers,
  } = useQuery(queries.products.GET_SPECIAL_OFFERS, {
    variables: { type: productType.MUSHROOM },
  });

  const {
    loading: tpLoading,
    error: tpError,
    data: dataTrendingProducts,
  } = useQuery(queries.products.GET_TRENDING_PRODUCTS, {});

  useEffect(() => {
    if (
      dataNewArrivals != null &&
      dataSpecialOffers != null &&
      dataTrendingProducts != null
    ) {
      ImportMainJs();
    }
  }, [dataNewArrivals, dataSpecialOffers, dataTrendingProducts]);

  return (
    <>
      <section className="section mt-4">
        <div className="container-fluid p-0">
          <div className="row">
            {/* Left column: 1 image */}
            <div
              className={
                isMobileScreen()
                  ? "col-md-6 m-0 pb-0 pl-0 pr-1"
                  : "col-md-6 m-0 pt-1 pb-0 pl-0 pr-1"
              }
            >
              <a href="/products?search=Opia" className="d-block h-100 w-100">
                <img
                  src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/home-banner1.png"
                  alt="OPMS 7OH"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    minHeight: 200,
                  }}
                />
              </a>
            </div>
            {/* Right column: 2 columns */}
            <div className="col-md-6 m-0 pt-1 pb-0">
              <div className="row h-100">
                {/* Top left: 1 image */}
                <div className="col-6 m-0 py-0 pl-0 pr-1">
                  <a
                    href="/products?search=EDP"
                    className="d-block h-100 w-100"
                  >
                    <img
                      src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/IMG_1406.JPG"
                      alt="EDP 7OH"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        minHeight: 200,
                      }}
                    />
                  </a>
                </div>
                {/* Top right: 2 stacked images */}
                <div
                  className="col-6 m-0 d-flex flex-column p-0"
                  style={{ gap: "4px" }}
                >
                  <a
                    href="/products?search=Polka"
                    className="d-block w-100"
                    style={{ flex: 1 }}
                  >
                    <img
                      src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/IMG_1423.JPG"
                      alt="Polka Dot"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        minHeight: 98,
                      }}
                    />
                  </a>
                  {/* <a
                    href="/products"
                    className="d-block w-100"
                    style={{ flex: 1 }}
                  >
                    <img
                      src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/typorama.png"
                      alt="Liquid Liftoff"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        minHeight: 98,
                      }}
                    />
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="swiper-pagination"></div>
        <div className="swiper-button-prev">
          <svg
            className="icon-svg-outline"
            width="15"
            height="26"
            viewBox="0 0 15 26"
            fill="none"
          >
            <path
              d="M14 25L2 13L14 1"
              strokeWidth="2"
              strokeLinecap="round"
            ></path>
          </svg>
        </div>
        <div className="swiper-button-next">
          <svg
            className="icon-svg-outline"
            width="15"
            height="26"
            viewBox="0 0 15 26"
            fill="none"
          >
            <path
              d="M1 25L13 13L0.999999 1"
              strokeWidth="2"
              strokeLinecap="round"
            ></path>
          </svg>
        </div>
      </section>

      <section className="section section-sm bg-white">
        <div className="container">
          <div className="text-center">
            <h3>Put yourself to HIGH level</h3>
            <p>
              A smoke shop specializing in high-quality products for Hemp
              enthusiasts.
              <br className="d-none d-xl-block" /> From premium strains to
              smoking accessories, we offer everything you need for an elevated
              smoking experience.
            </p>
          </div>
          <div className="row row-30 justify-content-center">
            <div className="col-auto">
              <div className="blurb">
                <div className="blurb-icon">
                  <FaCannabis color="#C58940" size={40} />
                </div>
                <div className="blurb-text">Top Brands</div>
              </div>
            </div>
            <div className="col-auto">
              <div className="blurb">
                <div className="blurb-icon">
                  <FaShippingFast color="#C58940" size={40} />
                </div>
                <div className="blurb-text">Free Shipping</div>
              </div>
            </div>
            <div className="col-auto">
              <div className="blurb">
                <div className="blurb-icon">
                  <FaAward color="#C58940" size={40} />
                </div>
                <div className="blurb-text">Quality Guarantee</div>
              </div>
            </div>
            <div className="col-auto">
              <div className="blurb">
                <div className="blurb-icon">
                  <FaHandHoldingDollar color="#C58940" size={40} />
                </div>
                <div className="blurb-text">Best Prices</div>
              </div>
            </div>
            <div className="col-auto">
              <div className="blurb">
                <div className="blurb-icon">
                  <TbShieldDollar color="#C58940" size={40} />
                </div>
                <div className="blurb-text">Secure Checkout</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="row no-gutters">
          <div className="col-lg-3 col-xs-6">
            <div className="thumb context-dark">
              <figure className="thumb-figure">
                <img
                  src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/home-01-480x560.jpg"
                  alt=""
                  width="480"
                  height="560"
                />
              </figure>
              <div className="thumb-body">
                <h3 className="thumb-text">Kratom</h3>
                <a className="btn btn-white" href="/products/kratom">
                  Show More Details
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-xs-6">
            <div className="thumb context-dark">
              <figure className="thumb-figure">
                <img
                  src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/vape-home-480x560.jpeg"
                  alt=""
                  width="480"
                  height="560"
                />
              </figure>
              <div className="thumb-body">
                <h3 className="thumb-text">7-OH</h3>
                <a className="btn btn-white" href="/products/7oh">
                  Show More Details
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-xs-6">
            <div className="thumb context-dark">
              <figure className="thumb-figure">
                <img
                  src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/home-03-480x560.jpg"
                  alt=""
                  width="480"
                  height="560"
                />
              </figure>
              <div className="thumb-body">
                <h3 className="thumb-text">Hemp & Delta</h3>
                <a className="btn btn-white" href="/products/delta8">
                  Show More Details
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-xs-6">
            <div className="thumb context-dark">
              <figure className="thumb-figure">
                <img
                  src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/home-04-480x560.jpg"
                  alt=""
                  width="480"
                  height="560"
                />
              </figure>
              <div className="thumb-body">
                <h3 className="thumb-text">Mushroom</h3>
                <a className="btn btn-white" href="/products/mushroom">
                  Show More Details
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-lg bg-primary-light">
        <div className="container">
          <div className="row row-50 align-items-center">
            <div className="col-md-6">
              <h3>
                Feel Elevated, Blaze Up,
                <br className="d-none d-xl-block" />
                Get Stoned
              </h3>
              <h5>
                Our selection of edibles, concentrates, and pre-rolls is always
                changing to offer you the latest and greatest in the Hemp
                industry.
              </h5>
              <h5>
                Whether you're a seasoned smoker or new to the scene, we have
                products that will suit your needs and preferences.
              </h5>
              <a className="btn btn-primary" href="/products">
                More Info
              </a>
            </div>
            <div className="col-md-6">
              <img
                src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/home-05-880x550.jpg"
                alt=""
                width="880"
                height="550"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section section-sm bg-white text-center">
        <div className="container">
          <p>Top sale in this week</p>
          <h3>Choose the Right Product</h3>
          <div
            className="tabs-custom tabs-horizontal tabs-corporate"
            id="tabs-1"
          >
            <ul className="nav nav-tabs">
              {dataTrendingProducts?.getTrendingProducts?.find(
                (tp) => tp.type === productType.KRATOM
              )?.products?.length >= MIN_TRENDING_PRODUCT && (
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link"
                    href="#tabs-kratom"
                    data-toggle="tabs"
                  >
                    Kratom
                  </a>
                </li>
              )}
              {dataTrendingProducts?.getTrendingProducts?.find(
                (tp) => tp.type === productType.DELTA8
              )?.products?.length >= MIN_TRENDING_PRODUCT && (
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link"
                    href="#tabs-delta8"
                    data-toggle="tabs"
                  >
                    Hemp & Delta
                  </a>
                </li>
              )}
              {dataTrendingProducts?.getTrendingProducts?.find(
                (tp) => tp.type === productType.CBD
              )?.products?.length >= MIN_TRENDING_PRODUCT && (
                <li className="nav-item" role="presentation">
                  <a className="nav-link" href="#tabs-cbd" data-toggle="tab">
                    CBD
                  </a>
                </li>
              )}
              {dataTrendingProducts?.getTrendingProducts?.find(
                (tp) => tp.type === productType.MUSHROOM
              )?.products?.length >= MIN_TRENDING_PRODUCT && (
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link"
                    href="#tabs-mushroom"
                    data-toggle="tab"
                  >
                    Mushroom
                  </a>
                </li>
              )}
              {dataTrendingProducts?.getTrendingProducts?.find(
                (tp) => tp.type === productType.GLASS
              )?.products?.length >= MIN_TRENDING_PRODUCT && (
                <li className="nav-item" role="presentation">
                  <a className="nav-link" href="#tabs-glass" data-toggle="tab">
                    Glass
                  </a>
                </li>
              )}
              {dataTrendingProducts?.getTrendingProducts?.find(
                (tp) => tp.type === productType.NICOTINE
              )?.products?.length >= MIN_TRENDING_PRODUCT && (
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link"
                    href="#tabs-nicotine"
                    data-toggle="tab"
                  >
                    Nicotine
                  </a>
                </li>
              )}
            </ul>
            <div className="tab-content">
              <div className="tab-pane fade" id="tabs-kratom">
                <div
                  className="owl-carousel owl-theme owl-carousel-style-2"
                  data-items="1"
                  data-xl-margin="40"
                  data-xs-items="2"
                  data-sm-items="2"
                  data-md-items="3"
                  data-lg-items="3"
                  data-xl-items="4"
                  data-owl='{"dots":true,"nav":false,"autoplayTimeout":3500,"margin":30,"stagePadding":0}'
                >
                  {dataTrendingProducts?.getTrendingProducts
                    ?.find((tp) => tp.type === productType.KRATOM)
                    ?.products?.slice(
                      0,
                      Math.min(
                        dataTrendingProducts?.getTrendingProducts?.find(
                          (tp) => tp.type === productType.KRATOM
                        )?.products?.length,
                        MIN_TRENDING_PRODUCT *
                          Math.floor(
                            dataTrendingProducts?.getTrendingProducts?.find(
                              (tp) => tp.type === productType.KRATOM
                            )?.products?.length / MIN_TRENDING_PRODUCT
                          )
                      )
                    )
                    ?.map((product) => {
                      return (
                        <ProductCard
                          key={product?._id}
                          product={product}
                          refetch={refetchSelf}
                        />
                      );
                    })}
                </div>
              </div>
              <div className="tab-pane fade" id="tabs-delta8">
                <div
                  className="owl-carousel owl-theme owl-carousel-style-2"
                  data-items="1"
                  data-xl-margin="40"
                  data-xs-items="2"
                  data-sm-items="2"
                  data-md-items="3"
                  data-lg-items="3"
                  data-xl-items="4"
                  data-owl='{"dots":true,"nav":false,"autoplayTimeout":3500,"margin":30,"stagePadding":0}'
                >
                  {dataTrendingProducts?.getTrendingProducts
                    ?.find((tp) => tp.type === productType.DELTA8)
                    ?.products?.slice(
                      0,
                      Math.min(
                        dataTrendingProducts?.getTrendingProducts?.find(
                          (tp) => tp.type === productType.DELTA8
                        )?.products?.length,
                        MIN_TRENDING_PRODUCT *
                          Math.floor(
                            dataTrendingProducts?.getTrendingProducts?.find(
                              (tp) => tp.type === productType.DELTA8
                            )?.products?.length / MIN_TRENDING_PRODUCT
                          )
                      )
                    )
                    ?.map((product) => {
                      return (
                        <ProductCard
                          key={product?._id}
                          product={product}
                          refetch={refetchSelf}
                        />
                      );
                    })}
                </div>
              </div>
              <div className="tab-pane fade" id="tabs-cbd">
                <div
                  className="owl-carousel owl-theme owl-carousel-style-2"
                  data-items="1"
                  data-xl-margin="40"
                  data-xs-items="2"
                  data-sm-items="2"
                  data-md-items="3"
                  data-lg-items="3"
                  data-xl-items="4"
                  data-owl='{"dots":true,"nav":false,"autoplayTimeout":3500,"margin":30,"stagePadding":0}'
                >
                  {dataTrendingProducts?.getTrendingProducts
                    ?.find((tp) => tp.type === productType.CBD)
                    ?.products?.slice(
                      0,
                      Math.min(
                        dataTrendingProducts?.getTrendingProducts?.find(
                          (tp) => tp.type === productType.CBD
                        )?.products?.length,
                        MIN_TRENDING_PRODUCT *
                          Math.floor(
                            dataTrendingProducts?.getTrendingProducts?.find(
                              (tp) => tp.type === productType.CBD
                            )?.products?.length / MIN_TRENDING_PRODUCT
                          )
                      )
                    )
                    ?.map((product) => {
                      return (
                        <ProductCard
                          key={product?._id}
                          product={product}
                          refetch={refetchSelf}
                        />
                      );
                    })}
                </div>
              </div>
              <div className="tab-pane fade" id="tabs-mushroom">
                <div
                  className="owl-carousel owl-theme owl-carousel-style-2"
                  data-items="1"
                  data-xl-margin="40"
                  data-xs-items="2"
                  data-sm-items="2"
                  data-md-items="3"
                  data-lg-items="3"
                  data-xl-items="4"
                  data-owl='{"dots":true,"nav":false,"autoplayTimeout":3500,"margin":30,"stagePadding":0}'
                >
                  {dataTrendingProducts?.getTrendingProducts
                    ?.find((tp) => tp.type === productType.MUSHROOM)
                    ?.products?.slice(
                      0,
                      Math.min(
                        dataTrendingProducts?.getTrendingProducts?.find(
                          (tp) => tp.type === productType.MUSHROOM
                        )?.products?.length,
                        MIN_TRENDING_PRODUCT *
                          Math.floor(
                            dataTrendingProducts?.getTrendingProducts?.find(
                              (tp) => tp.type === productType.MUSHROOM
                            )?.products?.length / MIN_TRENDING_PRODUCT
                          )
                      )
                    )
                    ?.map((product) => {
                      return (
                        <ProductCard
                          key={product?._id}
                          product={product}
                          refetch={refetchSelf}
                        />
                      );
                    })}
                </div>
              </div>
              <div className="tab-pane fade" id="tabs-glass">
                <div
                  className="owl-carousel owl-theme owl-carousel-style-2"
                  data-items="1"
                  data-xl-margin="40"
                  data-xs-items="2"
                  data-sm-items="2"
                  data-md-items="3"
                  data-lg-items="3"
                  data-xl-items="4"
                  data-owl='{"dots":true,"nav":false,"autoplayTimeout":3500,"margin":30,"stagePadding":0}'
                >
                  {dataTrendingProducts?.getTrendingProducts
                    ?.find((tp) => tp.type === productType.GLASS)
                    ?.products?.slice(
                      0,
                      Math.min(
                        dataTrendingProducts?.getTrendingProducts?.find(
                          (tp) => tp.type === productType.GLASS
                        )?.products?.length,
                        MIN_TRENDING_PRODUCT *
                          Math.floor(
                            dataTrendingProducts?.getTrendingProducts?.find(
                              (tp) => tp.type === productType.GLASS
                            )?.products?.length / MIN_TRENDING_PRODUCT
                          )
                      )
                    )
                    ?.map((product) => {
                      return (
                        <ProductCard
                          key={product?._id}
                          product={product}
                          refetch={refetchSelf}
                        />
                      );
                    })}
                </div>
              </div>
              <div className="tab-pane fade" id="tabs-nicotine">
                <div
                  className="owl-carousel owl-theme owl-carousel-style-2"
                  data-items="1"
                  data-xl-margin="40"
                  data-xs-items="2"
                  data-sm-items="2"
                  data-md-items="3"
                  data-lg-items="3"
                  data-xl-items="4"
                  data-owl='{"dots":true,"nav":false,"autoplayTimeout":3500,"margin":30,"stagePadding":0}'
                >
                  {dataTrendingProducts?.getTrendingProducts
                    ?.find((tp) => tp.type === productType.NICOTINE)
                    ?.products?.slice(
                      0,
                      Math.min(
                        dataTrendingProducts?.getTrendingProducts?.find(
                          (tp) => tp.type === productType.NICOTINE
                        )?.products?.length,
                        MIN_TRENDING_PRODUCT *
                          Math.floor(
                            dataTrendingProducts?.getTrendingProducts?.find(
                              (tp) => tp.type === productType.NICOTINE
                            )?.products?.length / MIN_TRENDING_PRODUCT
                          )
                      )
                    )
                    ?.map((product) => {
                      return (
                        <ProductCard
                          key={product?._id}
                          product={product}
                          refetch={refetchSelf}
                        />
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section
        className="section section-xxl bg-image section-overlay-1"
        style={{ backgroundImage: "url(images/bg-01-1920x900.jpg)" }}
      >
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-md-6 col-sm-7">
              <h2 className="h1">
                Come visit us and experience the best smoke shop in town!
              </h2>
              <h5>
                Our knowledgeable and friendly staff is always available to
                answer any questions you may have and help you find the perfect
                product.
              </h5>
              <a className="btn btn-primary" href="/about-us">
                Know More
              </a>
            </div>
          </div>
        </div>
      </section> */}

      <section className="section section-sm bg-white">
        <div className="container">
          <div
            className="owl-carousel owl-theme owl-carousel-style-2"
            data-items="1"
            data-owl='{"dots":true,"nav":false,"autoplayTimeout":3500000,"navText":["&lt;svg class=\"icon-svg-outline\" width=\"15\" height=\"26\" viewBox=\"0 0 15 26\" fill=\"none\"&gt;\n&lt;path d=\"M14 25L2 13L14 1\" stroke-width=\"2\" stroke-linecap=\"round\"/&gt;\n&lt;/svg&gt;","&lt;svg class=\"icon-svg-outline\" width=\"15\" height=\"26\" viewBox=\"0 0 15 26\" fill=\"none\"&gt;\n&lt;svg width=\"15\" height=\"26\" viewBox=\"0 0 15 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"&gt;&lt;path d=\"M1 25L13 13L0.999999 1\" stroke=\"#084B6D\" stroke-width=\"2\" stroke-linecap=\"round\"/&gt;\n&lt;path d=\"M1 25L13 13L0.999999 1\" stroke-width=\"2\" stroke-linecap=\"round\"/&gt;&lt;/svg&gt;"]}'
          >
            <div className="testimonials">
              <div className="testimonials-rating">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
              </div>
              <blockquote className="testimonials-body">
                <p className="testimonials-text h4">
                  "I've been ordering from this online cannabis shop for over a
                  year now, and I have never been disappointed. Their product is
                  always top-notch, and their customer service is second to
                  none. I highly recommend them to anyone looking for a reliable
                  and trustworthy source of high-quality Hemp."
                </p>
                <div className="testimonials-author">
                  <cite>Jesica Alba</cite>
                </div>
              </blockquote>
            </div>
            <div className="testimonials">
              <div className="testimonials-rating">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
              </div>
              <blockquote className="testimonials-body">
                <p className="testimonials-text h4">
                  "I was a little hesitant to order cannabis online, but this
                  shop made the process so easy and convenient. Their website is
                  user-friendly, their shipping is fast and discreet, and their
                  product is exceptional. I'll definitely be a repeat customer!"
                </p>
                <div className="testimonials-author">
                  <cite>John Doe</cite>
                </div>
              </blockquote>
            </div>
            <div className="testimonials">
              <div className="testimonials-rating">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
              </div>
              <blockquote className="testimonials-body">
                <p className="testimonials-text h4">
                  "I've tried a lot of different online cannabis shops, and this
                  one is by far the best. Their selection is incredible, their
                  prices are competitive, and their customer service is
                  exceptional. I love that I can trust them to always provide me
                  with the best products and service. Highly recommend!"
                </p>
                <div className="testimonials-author">
                  <cite>Sam Kromstain</cite>
                </div>
              </blockquote>
            </div>
            <div className="testimonials">
              <div className="testimonials-rating">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9742 6.93419C17.9121 6.74325 17.7472 6.6041 17.5485 6.57528L11.9684 5.7644L9.47288 0.708003C9.38408 0.528003 9.20074 0.414062 9.00003 0.414062C8.79929 0.414062 8.61598 0.528003 8.52715 0.708003L6.03148 5.7644L0.451505 6.57528C0.252908 6.6041 0.0878505 6.74325 0.0258351 6.93415C-0.0362154 7.12508 0.0155344 7.33465 0.159288 7.47475L4.1969 11.4106L3.24389 16.9682C3.20992 17.1661 3.29128 17.366 3.45366 17.484C3.54552 17.5507 3.65433 17.5847 3.76367 17.5847C3.84762 17.5847 3.93185 17.5647 4.00899 17.5241L9 14.9001L13.9908 17.524C14.1685 17.6175 14.3838 17.6019 14.5462 17.4839C14.7085 17.366 14.7899 17.166 14.756 16.9681L13.8027 11.4106L17.8407 7.47471C17.9845 7.33465 18.0362 7.12508 17.9742 6.93419Z"
                    fill="#C58940"
                  ></path>
                </svg>
              </div>
              <blockquote className="testimonials-body">
                <p className="testimonials-text h4">
                  "I was blown away by the quality of the cannabis I received
                  from this online shop. Not only was it some of the best I've
                  ever had, but the packaging was so professional and discreet
                  that even my nosy neighbors had no idea what was inside. I
                  also appreciated the extra little touches, like the free
                  rolling papers that came with my order. Overall, I'm extremely
                  impressed with this shop and will definitely be ordering from
                  them again in the future."
                </p>
                <div className="testimonials-author">
                  <cite>Edna Barton</cite>
                </div>
              </blockquote>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="section section-sm bg-white">
        <div className="container">
          <div className="row no-gutters" data-lightgallery="group">
            <div className="col-md-6">
              <div className="row no-gutters">
                <div className="col-xs-6">
                  <a
                    className="thumb context-dark"
                    data-lightgallery="item"
                    href="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/gallery-01-original.jpg"
                  >
                    <figure className="thumb-figure">
                      <img
                        src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/gallery-01-290x290.jpg"
                        alt=""
                        width="290"
                        height="290"
                      />
                    </figure>
                    <div className="thumb-body">
                      <svg
                        width="31"
                        height="18"
                        viewBox="0 0 31 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.1972 12.6533C17.2275 12.6533 18.8733 11.0237 18.8733 9.01344C18.8733 8.96752 18.8715 8.92202 18.8698 8.87646C18.5333 9.02806 18.1598 9.11311 17.7661 9.11311C16.2917 9.11311 15.0966 7.92966 15.0966 6.46982C15.0966 6.07992 15.1825 5.71017 15.3356 5.37693C15.2896 5.37524 15.2437 5.37348 15.1972 5.37348C13.167 5.37348 11.5212 7.00312 11.5212 9.01338C11.5212 11.0236 13.167 12.6533 15.1972 12.6533Z"
                          fill="white"
                        ></path>
                        <path
                          d="M29.9311 8.55782C28.4623 6.0438 26.3503 3.93532 23.8233 2.46025C21.2191 0.940166 18.2363 0.136719 15.1973 0.136719C12.1582 0.136719 9.17543 0.940166 6.57127 2.46025C4.04424 3.93526 1.93223 6.04374 0.463472 8.55782L0.197266 9.01347L0.463472 9.46913C1.93223 11.9832 4.04424 14.0916 6.57127 15.5667C9.17543 17.0868 12.1582 17.8902 15.1973 17.8902C18.2363 17.8902 21.2191 17.0868 23.8233 15.5667C26.3503 14.0917 28.4623 11.9832 29.9311 9.46913L30.1973 9.01347L29.9311 8.55782ZM22.3241 9.01347C22.3241 12.9046 19.1269 16.0702 15.1973 16.0702C11.2676 16.0702 8.07048 12.9046 8.07048 9.01347C8.07048 5.12236 11.2676 1.95673 15.1973 1.95673C19.1269 1.95673 22.3241 5.12236 22.3241 9.01347ZM2.33169 9.01347C3.73723 6.79386 5.68975 5.0077 7.95554 3.78748C6.8727 5.25461 6.23246 7.06127 6.23246 9.01347C6.23246 10.9657 6.8727 12.7723 7.95554 14.2395C5.68975 13.0192 3.73723 11.2331 2.33169 9.01347ZM22.439 14.2395C23.5218 12.7723 24.1621 10.9657 24.1621 9.01347C24.1621 7.06127 23.5218 5.25461 22.439 3.78748C24.7048 5.0077 26.6573 6.79386 28.0628 9.01347C26.6573 11.2331 24.7048 13.0192 22.439 14.2395Z"
                          fill="white"
                        ></path>
                      </svg>
                    </div>
                  </a>
                </div>
                <div className="col-xs-6">
                  <a
                    className="thumb context-dark"
                    data-lightgallery="item"
                    href="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/gallery-02-original.jpg"
                  >
                    <figure className="thumb-figure">
                      <img
                        src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/gallery-02-290x290.jpg"
                        alt=""
                        width="290"
                        height="290"
                      />
                    </figure>
                    <div className="thumb-body">
                      <svg
                        width="31"
                        height="18"
                        viewBox="0 0 31 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.1972 12.6533C17.2275 12.6533 18.8733 11.0237 18.8733 9.01344C18.8733 8.96752 18.8715 8.92202 18.8698 8.87646C18.5333 9.02806 18.1598 9.11311 17.7661 9.11311C16.2917 9.11311 15.0966 7.92966 15.0966 6.46982C15.0966 6.07992 15.1825 5.71017 15.3356 5.37693C15.2896 5.37524 15.2437 5.37348 15.1972 5.37348C13.167 5.37348 11.5212 7.00312 11.5212 9.01338C11.5212 11.0236 13.167 12.6533 15.1972 12.6533Z"
                          fill="white"
                        ></path>
                        <path
                          d="M29.9311 8.55782C28.4623 6.0438 26.3503 3.93532 23.8233 2.46025C21.2191 0.940166 18.2363 0.136719 15.1973 0.136719C12.1582 0.136719 9.17543 0.940166 6.57127 2.46025C4.04424 3.93526 1.93223 6.04374 0.463472 8.55782L0.197266 9.01347L0.463472 9.46913C1.93223 11.9832 4.04424 14.0916 6.57127 15.5667C9.17543 17.0868 12.1582 17.8902 15.1973 17.8902C18.2363 17.8902 21.2191 17.0868 23.8233 15.5667C26.3503 14.0917 28.4623 11.9832 29.9311 9.46913L30.1973 9.01347L29.9311 8.55782ZM22.3241 9.01347C22.3241 12.9046 19.1269 16.0702 15.1973 16.0702C11.2676 16.0702 8.07048 12.9046 8.07048 9.01347C8.07048 5.12236 11.2676 1.95673 15.1973 1.95673C19.1269 1.95673 22.3241 5.12236 22.3241 9.01347ZM2.33169 9.01347C3.73723 6.79386 5.68975 5.0077 7.95554 3.78748C6.8727 5.25461 6.23246 7.06127 6.23246 9.01347C6.23246 10.9657 6.8727 12.7723 7.95554 14.2395C5.68975 13.0192 3.73723 11.2331 2.33169 9.01347ZM22.439 14.2395C23.5218 12.7723 24.1621 10.9657 24.1621 9.01347C24.1621 7.06127 23.5218 5.25461 22.439 3.78748C24.7048 5.0077 26.6573 6.79386 28.0628 9.01347C26.6573 11.2331 24.7048 13.0192 22.439 14.2395Z"
                          fill="white"
                        ></path>
                      </svg>
                    </div>
                  </a>
                </div>
                <div className="col-12">
                  <a
                    className="thumb context-dark"
                    data-lightgallery="item"
                    href="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/gallery-03-original.jpg"
                  >
                    <figure className="thumb-figure">
                      <img
                        src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/gallery-03-580x290.jpg"
                        alt=""
                        width="580"
                        height="290"
                      />
                    </figure>
                    <div className="thumb-body">
                      <svg
                        width="31"
                        height="18"
                        viewBox="0 0 31 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.1972 12.6533C17.2275 12.6533 18.8733 11.0237 18.8733 9.01344C18.8733 8.96752 18.8715 8.92202 18.8698 8.87646C18.5333 9.02806 18.1598 9.11311 17.7661 9.11311C16.2917 9.11311 15.0966 7.92966 15.0966 6.46982C15.0966 6.07992 15.1825 5.71017 15.3356 5.37693C15.2896 5.37524 15.2437 5.37348 15.1972 5.37348C13.167 5.37348 11.5212 7.00312 11.5212 9.01338C11.5212 11.0236 13.167 12.6533 15.1972 12.6533Z"
                          fill="white"
                        ></path>
                        <path
                          d="M29.9311 8.55782C28.4623 6.0438 26.3503 3.93532 23.8233 2.46025C21.2191 0.940166 18.2363 0.136719 15.1973 0.136719C12.1582 0.136719 9.17543 0.940166 6.57127 2.46025C4.04424 3.93526 1.93223 6.04374 0.463472 8.55782L0.197266 9.01347L0.463472 9.46913C1.93223 11.9832 4.04424 14.0916 6.57127 15.5667C9.17543 17.0868 12.1582 17.8902 15.1973 17.8902C18.2363 17.8902 21.2191 17.0868 23.8233 15.5667C26.3503 14.0917 28.4623 11.9832 29.9311 9.46913L30.1973 9.01347L29.9311 8.55782ZM22.3241 9.01347C22.3241 12.9046 19.1269 16.0702 15.1973 16.0702C11.2676 16.0702 8.07048 12.9046 8.07048 9.01347C8.07048 5.12236 11.2676 1.95673 15.1973 1.95673C19.1269 1.95673 22.3241 5.12236 22.3241 9.01347ZM2.33169 9.01347C3.73723 6.79386 5.68975 5.0077 7.95554 3.78748C6.8727 5.25461 6.23246 7.06127 6.23246 9.01347C6.23246 10.9657 6.8727 12.7723 7.95554 14.2395C5.68975 13.0192 3.73723 11.2331 2.33169 9.01347ZM22.439 14.2395C23.5218 12.7723 24.1621 10.9657 24.1621 9.01347C24.1621 7.06127 23.5218 5.25461 22.439 3.78748C24.7048 5.0077 26.6573 6.79386 28.0628 9.01347C26.6573 11.2331 24.7048 13.0192 22.439 14.2395Z"
                          fill="white"
                        ></path>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <a
                className="thumb context-dark"
                data-lightgallery="item"
                href="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/gallery-04-original.jpg"
              >
                <figure className="thumb-figure">
                  <img
                    src="https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/gallery-04-580x580.jpg"
                    alt=""
                    width="580"
                    height="580"
                  />
                </figure>
                <div className="thumb-body">
                  <svg
                    width="31"
                    height="18"
                    viewBox="0 0 31 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.1972 12.6533C17.2275 12.6533 18.8733 11.0237 18.8733 9.01344C18.8733 8.96752 18.8715 8.92202 18.8698 8.87646C18.5333 9.02806 18.1598 9.11311 17.7661 9.11311C16.2917 9.11311 15.0966 7.92966 15.0966 6.46982C15.0966 6.07992 15.1825 5.71017 15.3356 5.37693C15.2896 5.37524 15.2437 5.37348 15.1972 5.37348C13.167 5.37348 11.5212 7.00312 11.5212 9.01338C11.5212 11.0236 13.167 12.6533 15.1972 12.6533Z"
                      fill="white"
                    ></path>
                    <path
                      d="M29.9311 8.55782C28.4623 6.0438 26.3503 3.93532 23.8233 2.46025C21.2191 0.940166 18.2363 0.136719 15.1973 0.136719C12.1582 0.136719 9.17543 0.940166 6.57127 2.46025C4.04424 3.93526 1.93223 6.04374 0.463472 8.55782L0.197266 9.01347L0.463472 9.46913C1.93223 11.9832 4.04424 14.0916 6.57127 15.5667C9.17543 17.0868 12.1582 17.8902 15.1973 17.8902C18.2363 17.8902 21.2191 17.0868 23.8233 15.5667C26.3503 14.0917 28.4623 11.9832 29.9311 9.46913L30.1973 9.01347L29.9311 8.55782ZM22.3241 9.01347C22.3241 12.9046 19.1269 16.0702 15.1973 16.0702C11.2676 16.0702 8.07048 12.9046 8.07048 9.01347C8.07048 5.12236 11.2676 1.95673 15.1973 1.95673C19.1269 1.95673 22.3241 5.12236 22.3241 9.01347ZM2.33169 9.01347C3.73723 6.79386 5.68975 5.0077 7.95554 3.78748C6.8727 5.25461 6.23246 7.06127 6.23246 9.01347C6.23246 10.9657 6.8727 12.7723 7.95554 14.2395C5.68975 13.0192 3.73723 11.2331 2.33169 9.01347ZM22.439 14.2395C23.5218 12.7723 24.1621 10.9657 24.1621 9.01347C24.1621 7.06127 23.5218 5.25461 22.439 3.78748C24.7048 5.0077 26.6573 6.79386 28.0628 9.01347C26.6573 11.2331 24.7048 13.0192 22.439 14.2395Z"
                      fill="white"
                    ></path>
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section> */}

      {/* Newsletter Subscription Section */}
    </>
  );
}

export default Home;
